import { request } from '@umijs/max';

// 获取接单状态
export async function getTakingOrderStatus(
    options?: { [key: string]: any },
) {
    return request<API.TakingOrderStatusResult>('/user/taking-order/status', {
        method: 'GET',
        ...(options || {}),
    });
}

// 更新接单状态
export async function updateTakingOrderStatus(
    data: API.UpdateTakingOrderParams,
    options?: { [key: string]: any },
) {
    return request<API.TakingOrderStatusResult>('/user/taking-order', {
        method: 'PUT',
        data,
        ...(options || {}),
    });
} 